export enum EWebSocketMessageType {
    CONNECTION_PING = 'ping',
    CONNECTION_PONG = 'pong',
    CONNECTION_ERROR = 'error',
    NOTIFICATION = 'notification',
    CHAT_MESSAGE_CREATED = 'chat.message.created',
    CHAT_MESSAGE_STATUS_CHANGED = 'chat.message.status.changed',
    CHAT_MESSAGE_EDITED = 'chat.message.edited',
    CHAT_MESSAGE_DELETED = 'chat.message.deleted',
    CHAT_MESSAGE_UPDATED = 'chat.message.updated',
    CHAT_READ_UPDATED = 'chat.read.updated',
}
